import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { defaultInputDateTimeFormat } from 'assets/utils/data/Date';
import { useStatementBalanceProvider } from '../StatementBalance.Hooks';

export default function StatementBalanceFilters() {
  const { lang } = getLocales();
  const { listApi, dealersApi, dealerGroupsApi } = useStatementBalanceProvider();
  const { isDealer } = useAuthStore();

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      filters={listApi.body}
      onFilter={(newFilters) => listApi.execute({ ...newFilters, offset: 0 })}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search, offset: 0 }))}
      onSortById={(sort) => listApi.execute((body) => ({ ...body, ...sort }))}
      onReset={listApi.reset}
      onOpen={() => {
        if (!dealersApi.payload) dealersApi.execute((body) => body);
        if (!dealerGroupsApi.payload) dealerGroupsApi.execute((body) => body);
      }}
      render={({ tempFilters, setFilters }) => (
        <>
          {dealersApi?.payload?.data?.length > 1 && (
            <SelectInput
              name="dealerId"
              label={lang.dealers}
              data={dealersApi?.payload?.data?.map((item) => ({
                ...item.displayInfo,
                icon: <Icon class="fas-cloud" />,
              }))}
              isMultiselect
              value={tempFilters?.dealerId}
              onChange={setFilters}
              icon={<Icon class="fas-cloud" />}
              disabled={isDealer}
            />
          )}
          {dealerGroupsApi?.payload?.data?.length > 1 && (
            <SelectInput
              name="dealerGroupId"
              label={lang.dealerGroup}
              data={dealerGroupsApi?.payload?.data?.map((item) => ({
                ...item.displayInfo,
                icon: <Icon class="fas-cloud" />,
              }))}
              isMultiselect
              value={tempFilters?.dealerGroupId}
              onChange={setFilters}
              icon={<Icon class="fas-cloud" />}
            />
          )}
          <DateInput
            name="invoicingFromDateUtc"
            label={lang.invoicingFromDate}
            dateTimeFormat={defaultInputDateTimeFormat}
            value={tempFilters?.invoicingFromDateUtc}
            onChange={setFilters}
            icon={<Icon class="fas-calendar-alt" />}
          />
          <DateInput
            name="invoicingToDateUtc"
            label={lang.invoicingToDate}
            dateTimeFormat={defaultInputDateTimeFormat}
            value={tempFilters?.invoicingToDateUtc}
            onChange={setFilters}
            icon={<Icon class="fas-calendar-alt" />}
          />
          <DateInput
            name="modifiedAtFromDateUtc"
            label={lang.modifiedAtFromDate}
            dateTimeFormat={defaultInputDateTimeFormat}
            value={tempFilters?.modifiedAtFromDateUtc}
            onChange={setFilters}
            icon={<Icon class="fas-calendar-alt" />}
          />
          <DateInput
            name="modifiedAtToDateUtc"
            label={lang.modifiedAtToDate}
            dateTimeFormat={defaultInputDateTimeFormat}
            value={tempFilters?.modifiedAtToDateUtc}
            onChange={setFilters}
            icon={<Icon class="fas-calendar-alt" />}
          />
        </>
      )}
    />
  );
}
